<template>
    <div>
        <v-stepper vertical v-model="step" class="px-md-10 px-0">

            <v-stepper-step step="1">
                مرحله ۱
                <small>نوع سفارش</small>
            </v-stepper-step>
            <v-stepper-content class="mx-0 px-1 pr-2" step="1">
                <h5 class="pb-5 text-center"> {{ pageTitle }}</h5>
                <div class="m-3">
                    <v-text-field outlined
                                  dense
                                  v-model="data.organizationName"
                                  hint="لطفا نام مجموعه خود را وارد کنید."
                                  maxLength="50"
                                  counter="50"
                                  :rules="this.$rules.requiredString"
                                  label="نام مجموعه "
                                  append-icon="mdi-domain"/>
                </div>
                <div class="m-3">
                    <v-text-field outlined
                                  dense
                                  v-model="data.brandName"
                                  hint="لطفا نام برند خود را  وارد  کنید."
                                  maxLength="50"
                                  counter="50"
                                  :rules="this.$rules.requiredString"
                                  label="نام برند "
                                  append-icon="mdi-domain"/>
                </div>
                <div class="m-3">
                    <v-text-field outlined
                                  v-model="data.brandSlogan"
                                  dense
                                  :rules="this.$rules.requiredString"
                                  hint="لطفا شعار برند خود را وارد نمایید"
                                  placeholder="لطفا شعار برند خود را وارد نمایید"
                                  maxLength="50"
                                  counter="50"
                                  label="شعار برند"
                                  append-icon="mdi-domain"/>
                </div>
                <div class="m-3">
                    <v-switch
                            v-model="data.slogan"
                            dense
                            class="text-right"
                            label="میخواهم شعار در ست اداری اضافه شود"
                    ></v-switch>
                </div>
                <v-btn class="submit-btn" @click="step1Validate">
                    ادامه
                    <span class="fa fa-arrow-left mr-1"></span>
                </v-btn>
            </v-stepper-content>

            <v-stepper-step step="2">
                مرحله ۲
                <small>اطلاعات اولیه سفارش</small>
            </v-stepper-step>
            <v-stepper-content class="mx-0 px-1 pr-2" step="2">
                <div class="mt-2">
                    <div>
                        <v-expansion-panels class="px-1">
                            <v-expansion-panel
                                    class="mb-4 px-1 customStyle"
                            >
                                <v-expansion-panel-header disable-icon-rotate class="px-1">
                                    نوع ست اداری خود را انتخاب نمایید.
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <office-type @persianName="persianName" v-model="chosenSet"
                                                 class="mb-4"></office-type>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel
                                    v-if="chosenSet.includes('notebook')"
                                    class="mb-4 px-1 customStyle"
                            >
                                <v-expansion-panel-header disable-icon-rotate class="px-1">
                                    لطفا نوع دفترچه یادداشت خود را انتخاب نمایید.

                                    <div v-if="data.noteBookType && !isMobile && chosenSet.includes('notebook')">
                                        <v-chip
                                                v-if="data.noteBookType && chosenSet.includes('notebook')"
                                                close-icon="mdi-close-outline"
                                                color="indigo"
                                                small
                                                class="mx-2"
                                                outlined
                                        >{{ names['notePhone'] }}
                                        </v-chip>
                                    </div>
                                    <template v-slot:actions>
                                        <v-icon v-if="data.noteBookType && isMobile" color="teal">mdi-check</v-icon>
                                    </template>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <note-phone v-if="chosenSet.includes('notebook')"
                                                @persianName="persianName" v-model="data.noteBookType"
                                                class="mb-4"></note-phone>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel
                                    v-if="chosenSet.includes('notebook')"
                                    class="mb-4 px-1 customStyle"
                            >
                                <v-expansion-panel-header disable-icon-rotate class="px-1">
                                    لطفا سایز و جهت بازشدن دفترچه یادداشت خودرا انتخاب کنید .

                                    <div class="row mr-2" v-if="!isMobile && chosenSet.includes('notebook')">
                                        <div v-if="data.noteBookSize && chosenSet.includes('notebook')">
                                            <v-chip
                                                    v-if="data.noteBookSize && chosenSet.includes('notebook')"
                                                    close-icon="mdi-close-outline"
                                                    color="indigo"
                                                    small
                                                    class="mx-2"
                                                    outlined
                                            >{{ noteSize.find((x) => x.value === data.noteBookSize).text }}
                                            </v-chip>
                                        </div>
                                        <div v-if="data.noteBookSide">
                                            <v-chip
                                                    v-if="data.noteBookSide && chosenSet.includes('notebook')"
                                                    close-icon="mdi-close-outline"
                                                    color="indigo"
                                                    small
                                                    class="mx-2"
                                                    outlined
                                            >{{ notedirection.find((x) => x.value === data.noteBookSide).text }}
                                            </v-chip>
                                        </div>
                                    </div>
                                    <template v-slot:actions>
                                        <v-icon v-if="data.noteBookSide && data.noteBookSize && isMobile" color="teal">
                                            mdi-check
                                        </v-icon>
                                    </template>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-autocomplete
                                            class="m-1"
                                            v-model="data.noteBookSize"
                                            :items="noteSize"
                                            v-if="chosenSet.includes('notebook')"
                                            dense
                                            item-text="text"
                                            item-value="value"
                                            label="سایز دفترچه"
                                            placeholder="لطفا سایز مورد نظر دفترچه یادداشت خود را انتخاب نمایید."
                                            hint="لطفا سایز مورد نظر دفترچه یادداشت خود را انتخاب نمایید."
                                            outlined
                                    ></v-autocomplete>
                                    <v-autocomplete
                                            v-if="chosenSet.includes('notebook')"
                                            class="m-1"
                                            v-model="data.noteBookSide"
                                            :items="notedirection"
                                            dense
                                            item-text="text"
                                            item-value="value"
                                            label="جهت بازشدن دفترچه"
                                            placeholder="لطفا جهت بازشدن دفترچه یادداشت خود را انتخاب نمایید."
                                            hint="لطفا جهت بازشدن دفترچه یادداشت خود را انتخاب نمایید."
                                            outlined
                                    ></v-autocomplete>
                                    <p>لطفا مطالب مورد نظر دفترچه یادداشت خودرا برای ما تایپ نمایید.</p>
                                    <V8Editor :class="isMobile?'' : 'mt-3'" v-if="chosenSet.includes('notebook')"
                                              v-model="data.noteBookText"/>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel
                                    v-if="chosenSet.includes('foolder')"
                                    class="mb-4 px-1 customStyle"
                            >
                                <v-expansion-panel-header disable-icon-rotate class="px-1">
                                    لطفا مدل فولدر خود را انتخاب نمایید .

                                    <div v-if="data.folderType && !isMobile">
                                        <v-chip
                                                v-if="data.folderType"
                                                close-icon="mdi-close-outline"
                                                color="indigo"
                                                small
                                                class="mx-2"
                                                outlined
                                        >{{ names['fooldersType'] }}
                                        </v-chip>
                                    </div>
                                    <template v-slot:actions>
                                        <v-icon v-if="data.folderType && isMobile" color="teal">mdi-check</v-icon>
                                    </template>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <foolders-type @persianName="persianName" v-model="data.folderType"
                                                   class="mb-4"></foolders-type>

                                    <p class="pb-2">لطفا مطالب مورد نظر فولدر(پوشه تبلیغاتی) خودرا برای ما تایپ
                                        نمایید.</p>
                                    <V8Editor v-model="data.folderText"/>

                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel
                                    class="mb-4 px-1 customStyle"
                                    v-if="data.type==='header' || (data.type==='office_set' && chosenSet.includes('header'))"
                            >
                                <v-expansion-panel-header disable-icon-rotate class="px-1">
                                    لطفا سایز سربرگ خود را انتخاب نمایید .
                                    <div class="row mr-2" v-if="!isMobile && chosenSet.includes('header')">
                                        <div v-if="data.size.length>0">
                                            <v-chip
                                                    v-if="data.size.length>0"
                                                    close-icon="mdi-close-outline"
                                                    color="indigo"
                                                    small
                                                    class="mx-2"
                                                    outlined
                                            >{{ data.size.toString() }}
                                            </v-chip>
                                        </div>
                                        <div v-if="data.orientation">
                                            <v-chip
                                                    v-if="data.orientation"
                                                    close-icon="mdi-close-outline"
                                                    color="indigo"
                                                    small
                                                    class="mx-2"
                                                    outlined
                                            >{{ data.orientation === 'horizontal' ? 'افقی' : 'عمودی' }}
                                            </v-chip>
                                        </div>
                                    </div>
                                    <template v-slot:actions>
                                        <v-icon v-if="data.size.length>0 && isMobile" color="teal">mdi-check</v-icon>
                                    </template>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-autocomplete
                                            class="m-1"
                                            v-model="data.size"
                                            :items="headerSize"
                                            dense
                                            multiple
                                            v-if="chosenSet.includes('header')"
                                            item-text="text"
                                            item-value="value"
                                            label="سایز سربرگ"
                                            placeholder="لطفا یک گزینه را انتخاب نمایید."
                                            hint="لطفا یک گزینه را انتخاب نمایید."
                                            outlined
                                    ></v-autocomplete>
                                    <v-radio-group v-if="chosenSet.includes('header')" class="mt-0 ot-0" row
                                                   v-model="data.orientation">
                                        <v-radio
                                                value="vertical"
                                        >
                                            <template v-slot:label>
                                                <img src='@/assets/double-arrow-vertical-symbol.png' class="" width="20"
                                                     alt="">
                                                <span>عمودی</span>
                                            </template>
                                        </v-radio>
                                        <v-radio
                                                label="افقی"
                                                value="horizontal"
                                                class="my-2"
                                        >
                                            <template v-slot:label>
                                                <img src='@/assets/double-arrow-horizontal-symbol.png' width="20"
                                                     class="ml-2" alt="">
                                                <span>افقی</span>
                                            </template>
                                        </v-radio>
                                    </v-radio-group>
                                    <p class="pb-2">لطفا مطالب مورد نظر سربرگ خودرا برای ما تایپ نمایید.</p>
                                    <V8Editor :class="isMobile?'' : 'mt-3'" v-if="chosenSet.includes('header')"
                                              v-model="data.headerTexts"/>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel
                                    class="mb-4 px-1 customStyle"
                                    v-if="data.type==='header'"
                            >
                                <v-expansion-panel-header disable-icon-rotate class="px-1">
                                    لطفا شکل هندسی سربرگ خود را انتخاب نمایید .
                                    <div v-if="data.diagram && !isMobile">
                                        <v-chip
                                                v-if="data.diagram"
                                                close-icon="mdi-close-outline"
                                                color="indigo"
                                                small
                                                class="mx-2"
                                                outlined
                                        >{{ names["headerShape"] }}
                                        </v-chip>
                                    </div>
                                    <template v-slot:actions>
                                        <v-icon v-if="data.diagram && isMobile" color="teal">mdi-check</v-icon>
                                    </template>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <header-shape @persianName="persianName" v-model="data.diagram" class="mb-4"
                                                  v-if="data.type==='header'"></header-shape>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel
                                    class="mb-4 px-1 customStyle"
                                    v-if="chosenSet.includes('letter')"
                            >
                                <v-expansion-panel-header disable-icon-rotate class="px-1">
                                    لطفا نوع پاکت نامه خود را انتخاب نمایید.
                                    <v-row class="mx-2" v-if="!isMobile && chosenSet.includes('letter')">
                                        <div v-if="data.pocketOrientation">
                                            <v-chip
                                                    v-if="data.pocketOrientation && chosenSet.includes('letter')"
                                                    close-icon="mdi-close-outline"
                                                    color="indigo"
                                                    small
                                                    class="mx-2"
                                                    outlined
                                            >{{ names["letterSet"] }}
                                            </v-chip>
                                        </div>
                                        <div v-if="data.pocketSize">
                                            <v-chip
                                                    v-if="data.pocketSize && chosenSet.includes('letter')"
                                                    close-icon="mdi-close-outline"
                                                    color="indigo"
                                                    small
                                                    class="mx-2"
                                                    outlined
                                            >{{ data.pocketSize }}
                                            </v-chip>
                                        </div>
                                    </v-row>
                                    <template v-slot:actions>
                                        <v-icon v-if="data.pocketOrientation && data.pocketSize && isMobile"
                                                color="teal">mdi-check
                                        </v-icon>
                                    </template>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-autocomplete
                                            class="m-1"
                                            v-model="data.pocketSize"
                                            v-if="chosenSet.includes('letter')"
                                            :items="pocketSize"
                                            dense
                                            item-text="text"
                                            item-value="value"
                                            label="سایز پاکت نامه"
                                            placeholder="لطفا یک گزینه را انتخاب نمایید."
                                            hint="لطفا یک گزینه را انتخاب نمایید."
                                            outlined
                                    ></v-autocomplete>
                                    <letter-set v-if="chosenSet.includes('letter')" @persianName="persianName"
                                                class="mb-4"
                                                v-model="data.pocketOrientation"></letter-set>

                                    <p class="pb-2">لطفا مطالب مورد نظر پاکت نامه خودرا برای ما تایپ نمایید.</p>
                                    <V8Editor :class="isMobile?'' : 'mt-3'" v-if="chosenSet.includes('letter')"
                                              v-model="data.pocketText"/>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel
                                    class="mb-4 px-1 customStyle"
                                    v-if="data.type==='office_set' && chosenSet.includes('visitCard')"
                            >
                                <v-expansion-panel-header disable-icon-rotate class="px-1">
                                    لطفا نوع کارت ویزیت خود را انتخاب نمایید .
                                    <div class="row mr-2" v-if="!isMobile">
                                        <div v-if="data.shapeSet">
                                            <v-chip
                                                    v-if="data.shapeSet"
                                                    close-icon="mdi-close-outline"
                                                    color="indigo"
                                                    small
                                                    class="mx-2"
                                                    outlined
                                            >{{ names["shapeCard"] }}
                                            </v-chip>
                                        </div>
                                        <div v-if="data.sides">
                                            <v-chip
                                                    v-if="data.sides"
                                                    close-icon="mdi-close-outline"
                                                    color="indigo"
                                                    small
                                                    class="mx-2"
                                                    outlined
                                            >{{ names["cardSides"] }}
                                            </v-chip>
                                        </div>
                                    </div>
                                    <template v-slot:actions>
                                        <v-icon v-if="data.shapeSet && data.sides && isMobile" color="teal">mdi-check
                                        </v-icon>
                                    </template>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <card-sides @persianName="persianName" v-model="data.sides"
                                                class="mb-4"></card-sides>
                                    <hr>

                                    <p>لطفا شکل هندسی کارت ویزیت خودرا انتخاب کنید.</p>
                                    <shape-type @persianName="persianName" v-model="data.shapeSet"
                                                class="mb-4"></shape-type>

                                    <p class="pb-2">لطفا مطالب مورد نظر روی کارت ویزیت خود را برای ما تایپ
                                        نمایید.</p>
                                    <V8Editor :class="isMobile?'' : 'mt-3'"
                                              v-model="data.frontVisitText"/>

                                    <p v-if="data.sides==='twoSide'" class="pb-2 mt-8">لطفا مطالب مورد نظر پشت کارت
                                        ویزیت خودرا برای ما تایپ
                                        نمایید.</p>
                                    <V8Editor :class="isMobile?'' : 'mt-3'" v-if="data.sides==='twoSide'"
                                              v-model="data.backVisitText"/>

                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </div>
                </div>
                <div class="row justify-content-between py-2 mx-auto">
                    <v-btn class="submit-btn col-md-1 col-3" @click="step2Validate">
                        ادامه
                        <span class="fa fa-arrow-left mr-1"></span>
                    </v-btn>
                    <v-btn class="mx-4 btn-refund col-md-1 col-3" @click="step = 1">
                        <span class="fa fa-arrow-right mr-1"></span>
                        بازگشت
                    </v-btn>
                </div>
            </v-stepper-content>

            <v-stepper-step step="3">
                مرحله ۳
                <small>مشخصات سایت</small>
            </v-stepper-step>
            <v-stepper-content class="mx-0 px-1 pr-2" step="3">
                <v-expansion-panels class="px-1">
                    <v-expansion-panel
                            class="mb-4 px-1 customStyle"
                            v-if="data.type==='office_set' || data.type==='header'  "
                    >
                        <v-expansion-panel-header disable-icon-rotate class="px-1">

                            {{
                                data.type === 'header' ? '  لطفا زبان طراحی سربرگ خود را انتخاب نمایید' : '  لطفا زبان طراحی ست اداری را انتخاب نمایید.'
                            }}
                            <div v-if="data.logoLanguage && !isMobile">
                                <v-chip
                                        v-if="data.logoLanguage"
                                        close-icon="mdi-close-outline"
                                        color="indigo"
                                        small
                                        class="mx-2"
                                        outlined
                                >{{ names["langType"] }}
                                </v-chip>
                            </div>
                            <template v-slot:actions>
                                <v-icon v-if="data.logoLanguage && isMobile" color="teal">mdi-check</v-icon>
                            </template>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <lang-type @persianName="persianName" v-model="data.logoLanguage"
                                       class="mb-4"></lang-type>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel class="mb-4 px-1 customStyle"
                                       v-if="data.type==='office_set' || data.type==='header'">
                        <v-expansion-panel-header disable-icon-rotate class="px-1">
                            {{
                                data.type === 'header' ? '  لطفا رنگ سربرگ خود را انتخاب نمایید' : '  لطفا رنگ  ست اداری را انتخاب نمایید .'
                            }}
                            <div v-if="data.color.length>0 && !isMobile">
                                <v-chip
                                        v-if="data.color.length>0"
                                        v-for="color in data.color"
                                        close-icon="mdi-close-outline"
                                        color="indigo"
                                        small
                                        :color="color"
                                        class="mx-2"
                                        outlined
                                >{{ color }}
                                </v-chip>
                            </div>
                            <template v-slot:actions>
                                <v-icon v-if="data.color.length > 0 && isMobile" color="teal">mdi-check</v-icon>
                            </template>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <color-pickers count="3" v-model="data.color" class="mb-4"></color-pickers>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel
                            class="mb-4 px-1 customStyle"
                    >
                        <v-expansion-panel-header disable-icon-rotate class="px-1">
                            لطفا نوع سفارش خودرا انتخاب کنید .

                            <div class="row mr-2" v-if="!isMobile">
                                <div v-if="data.orderType">
                                    <v-chip
                                            v-if="data.orderType"
                                            close-icon="mdi-close-outline"
                                            color="indigo"
                                            small
                                            class="mx-2"
                                            outlined
                                    >{{ orderType.find((x) => x.value === data.orderType).text }}
                                    </v-chip>
                                </div>
                                <div v-if="data.orderType==='designPrint' && data.printCount">
                                    <v-chip
                                            v-if="data.printCount"
                                            close-icon="mdi-close-outline"
                                            color="indigo"
                                            small
                                            class="mx-2"
                                            outlined
                                    >{{ data.printCount|currency|persianNum }} عدد
                                    </v-chip>
                                </div>
                            </div>
                            <template v-slot:actions>
                                <v-icon v-if="data.orderType && isMobile" color="teal">mdi-check</v-icon>
                            </template>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-autocomplete
                                    class="m-1"
                                    v-model="data.orderType"
                                    :items="orderType"
                                    dense
                                    item-text="text"
                                    item-value="value"
                                    label="نوع سفارش"
                                    placeholder="لطفا یک گزینه را انتخاب نمایید."
                                    hint="لطفا یک گزینه را انتخاب نمایید."
                                    outlined
                            ></v-autocomplete>
                            <v-text-field
                                    v-if="data.orderType==='designPrint'"
                                    class="m-1"
                                    v-model="printCounting"
                                    dense
                                    item-text="text"
                                    item-value="value"
                                    label="تعداد چاپ"
                                    placeholder="تعداد وارد شده با مضربی از 1000 محاسبه می شود."
                                    hint="تعداد وارد شده با مضربی از 1000 محاسبه می شود."
                                    outlined
                            ></v-text-field>
                            <v-autocomplete
                                    v-if="data.type==='visit_card'"
                                    class="m-1"
                                    :items="printType"
                                    dense
                                    item-text="text"
                                    item-value="value"
                                    label="نوع طرح"
                                    placeholder="لطفا یک گزینه را انتخاب نمایید."
                                    hint="لطفا یک گزینه را انتخاب نمایید."
                                    outlined
                            ></v-autocomplete>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel class="mb-4 px-1 customStyle">
                        <v-expansion-panel-header disable-icon-rotate class="px-1">
                            لطفا سبک طراحی خود رامشخص نمایید.
                            <div v-if="data.simpleness && !isMobile">
                                <v-chip
                                        v-if="data.simpleness"
                                        close-icon="mdi-close-outline"
                                        color="indigo"
                                        small
                                        class="mx-2"
                                        outlined
                                >{{ names["setDesignType"] }}
                                </v-chip>
                            </div>
                            <template v-slot:actions>
                                <v-icon v-if="data.simpleness && isMobile" color="teal">mdi-check</v-icon>
                            </template>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <set-design-type @persianName="persianName" class="mb-4"
                                             v-model="data.simpleness"></set-design-type>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel
                            class="mb-4 px-1 customStyle"
                    >
                        <v-expansion-panel-header disable-icon-rotate class="px-1">
                            لطفا نوع طراحی خود رامشخص نمایید.
                            <div v-if="data.complexity && !isMobile">
                                <v-chip
                                        v-if="data.complexity"
                                        close-icon="mdi-close-outline"
                                        color="indigo"
                                        small
                                        class="mx-2"
                                        outlined
                                >{{ names["complexSet"] }}
                                </v-chip>
                            </div>
                            <template v-slot:actions>
                                <v-icon v-if="data.complexity && isMobile" color="teal">mdi-check</v-icon>
                            </template>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <complex-set @persianName="persianName" class="mb-4"
                                         v-model="data.complexity"></complex-set>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel
                            class="mb-4 px-1 customStyle"
                            v-if="chosenSet.includes('notebook') && data.orderType==='designPrint'"
                    >
                        <v-expansion-panel-header disable-icon-rotate class="px-1">
                            لطفا جنس دفترچه یادداشت خود رامشخص نمایید.
                            <div v-if="data.material.noteBook && !isMobile && chosenSet.includes('notebook') && data.orderType==='designPrint'">
                                <v-chip
                                        v-if="data.material.noteBook"
                                        close-icon="mdi-close-outline"
                                        color="indigo"
                                        small
                                        class="mx-2"
                                        outlined
                                >{{ names["noteBookMAterial"] }}
                                </v-chip>
                            </div>
                            <template v-slot:actions>
                                <v-icon v-if="data.material.noteBook && isMobile" color="teal">mdi-check</v-icon>
                            </template>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <note-book @persianName="persianName" class="mb-4"
                                       v-model="data.material.noteBook"></note-book>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel
                            class="mb-4 px-1 customStyle"
                            v-if="chosenSet.includes('foolder') && data.orderType==='designPrint'"
                    >
                        <v-expansion-panel-header disable-icon-rotate class="px-1">
                            لطفا جنس پوشه خود رامشخص نمایید.
                            <div v-if="data.material.folder && !isMobile && chosenSet.includes('foolder') && data.orderType==='designPrint'">
                                <v-chip
                                        v-if="data.material.folder"
                                        close-icon="mdi-close-outline"
                                        color="indigo"
                                        small
                                        class="mx-2"
                                        outlined
                                >{{ names["folderMat"] }}
                                </v-chip>
                            </div>
                            <template v-slot:actions>
                                <v-icon v-if="data.material.folder && isMobile" color="teal">mdi-check</v-icon>
                            </template>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <folder-mat @persianName="persianName" class="mb-4"
                                        v-model="data.material.folder"></folder-mat>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel
                            class="mb-4 px-1 customStyle"
                            v-if="chosenSet.includes('letter') && data.orderType==='designPrint'"
                    >
                        <v-expansion-panel-header disable-icon-rotate class="px-1">
                            لطفا جنس پاکت نامه خود رامشخص نمایید.
                            <div v-if="data.material.letter && !isMobile && chosenSet.includes('letter') && data.orderType==='designPrint'">
                                <v-chip
                                        v-if="data.material.letter"
                                        close-icon="mdi-close-outline"
                                        color="indigo"
                                        small
                                        class="mx-2"
                                        outlined
                                >{{ names["lettrMat"] }}
                                </v-chip>
                            </div>
                            <template v-slot:actions>
                                <v-icon v-if="data.material.letter && isMobile" color="teal">mdi-check</v-icon>
                            </template>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <lettr-mat @persianName="persianName" class="mb-4"
                                       v-model="data.material.letter"></lettr-mat>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel
                            class="mb-4 px-1 customStyle"
                            v-if="chosenSet.includes('visitCard') && data.orderType==='designPrint'"
                    >
                        <v-expansion-panel-header disable-icon-rotate class="px-1">
                            لطفا جنس کارت ویزیت خود رامشخص نمایید.
                            <div v-if="data.material.visiCard && !isMobile && chosenSet.includes('visitCard') && data.orderType==='designPrint'">
                                <v-chip
                                        v-if="data.material.visiCard"
                                        close-icon="mdi-close-outline"
                                        color="indigo"
                                        small
                                        class="mx-2"
                                        outlined
                                >{{ names["visitType"] }}
                                </v-chip>
                            </div>
                            <template v-slot:actions>
                                <v-icon v-if="data.material.visiCard && isMobile" color="teal">mdi-check</v-icon>
                            </template>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <card-type @persianName="persianName" class="mb-4"
                                       v-model="data.material.visiCard"></card-type>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>

                <div class="row justify-content-between py-2 mx-auto">
                    <v-btn class="submit-btn col-md-1 col-3" @click="validIs">
                        ادامه
                        <span class="fa fa-arrow-left mr-1"></span>
                    </v-btn>
                    <v-btn class="mx-4 btn-refund col-md-1 col-3" @click="step = 2">
                        <span class="fa fa-arrow-right mr-1"></span>
                        بازگشت
                    </v-btn>
                </div>
            </v-stepper-content>


            <v-stepper-step step="4">
                مرحله ۴
                <small>مشخصات سایت</small>
            </v-stepper-step>
            <v-stepper-content class="mx-0 px-1 pr-2" step="4">
                <div class="mt-2" v-if="step2Validate">
                    <div class="">
                        <span class="text-center pb-2">لطفا عکس یک یا چندست اداری مورد علاقه خود را برای ما ارسال کنید. تا تیم طراحی ما نیاز شما را بهتر درک کنند.</span>
                    </div>
                    <v-file-input
                            v-model="data.file"
                            label=" بارگذاری عکس "
                            outlined
                            accept="image/png, image/jpeg,image/jpg, image/bmp"
                            placeholder="عکس موردنظر خود را بارگذاری کنید."
                            hint="حداکثر حجم هر عکس مورد نظر می‌تواند 1 مگابابت باشد."
                            prepend-inner-icon="mdi-camera"
                            clearable
                            small-chips
                            clear-icon="mdi-close-circle-outline"
                            prepend-icon=""
                            dense
                            multiple
                            class="mt-1 pt-1"
                    >
                    </v-file-input>
                    <div class="m-3">
                        <span class="text-center pb-2">لطفا لوگو برند خودرابارگذاری کنید</span>
                    </div>
                    <v-file-input
                            v-model="data.brandLogo"
                            label=" بارگذاری عکس "
                            outlined
                            accept="image/png,image/jpeg"
                            placeholder="لطفا لوگو برند خودرابارگذاری کنید."
                            hint="حداکثر حجم هر عکس مورد نظر می‌تواند 1 مگابابت باشد."
                            prepend-inner-icon="mdi-camera"
                            clearable
                            small-chips
                            clear-icon="mdi-close-circle-outline"
                            prepend-icon=""
                            dense
                            multiple
                            class="mt-1 mx-3 pt-1"
                    >
                    </v-file-input>
                </div>
                <div class="row justify-content-between py-2 mx-auto">
                    <v-btn class="submit-btn col-md-1 col-3" @click="step3Validate">
                        ادامه
                        <span class="fa fa-arrow-left mr-1"></span>
                    </v-btn>
                    <v-btn class="mx-4 btn-refund col-md-1 col-3" @click="step = 3">
                        <span class="fa fa-arrow-right mr-1"></span>
                        بازگشت
                    </v-btn>
                </div>
            </v-stepper-content>

            <v-stepper-step step="5">
                مرحله ۵
                <small>زمان تحویل</small>
            </v-stepper-step>
            <v-stepper-content class="mx-0 px-1 pr-2" step="5">
                <div class="mx-3">
                    <date-picker
                            v-model="data.deliveryTime"
                            color="#00acc1"
                            label="زمان تحویل"
                            input-class="mb-0 rounded"
                            persianDigits
                            clearable
                            :timezone="false"
                            format="YYYY-MM-DD"
                            style="font-size: 13px!important"
                            class="dateSet"
                            display-format="jMMMM jD"
                            :min="countDay"
                    />
                </div>
                <div class="m-3">
                    <v-text-field outlined
                                  dense
                                  v-model="data.businessDescription"
                                  hint="لطفا درمورد حوزه کسب وکارخود توضیح دهید."
                                  maxLength="50"
                                  counter="50"
                                  :rules="this.$rules.requiredString"
                                  label="حوزه کسب وکار "
                                  append-icon="mdi-domain"/>
                </div>

                <div class="row justify-content-between py-2 mx-auto">
                    <v-btn class="submit-btn col-md-1 col-3 mt-5" @click="step4Validate">
                        <span class="fa fa-arrow-left mr-1"></span>
                        ادامه
                    </v-btn>
                    <v-btn class="mx-4 mt-5 btn-refund col-md-1 col-3" @click="step = 4">
                        <span class="fa fa-arrow-right mr-1"></span>
                        بازگشت
                    </v-btn>
                </div>
            </v-stepper-content>

            <v-stepper-step step="6">
                مرحله ۶
                <small>توضیحات</small>
            </v-stepper-step>
            <v-stepper-content class="mx-0 px-1 pr-2" step="6">
                <div class="mt-1">
                    <div class="mb-2">
                        <span class="text-center pb-2">لطفا توضیحات تکمیلی خود در مورد نیازتان را برای متخصصان ما یادداشت نمایید، تا بتوانیم به بهترین شکل ممکن درخواست شما را بررسی و پاسخ دهیم.</span>
                    </div>

                    <V8Editor :class="isMobile?'' : 'mt-3'"
                              v-model="data.description"/>
                </div>

                <div class="row justify-content-between py-2 mx-auto">
                    <v-btn :loading="loading" class="submit-btn col-md-1 col-4 mt-5" @click="submit">
                        <span class="fa fa-save mr-1"></span>
                        ثبت سفارش
                    </v-btn>
                    <v-btn class="mx-4 mt-5 btn-refund col-md-1 col-4" @click="step = 5">
                        <span class="fa fa-arrow-right mr-1"></span>
                        بازگشت
                    </v-btn>
                </div>
            </v-stepper-content>

        </v-stepper>
    </div>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import CKEditorUploadAdapterPlugin from "../../../../core/plugins/CKEditorUploadFileAdapter";
import LogoType from "../../components/logoType";
import LangType from "../../components/langType";
import Properties from "../../components/properties";
import SabkType from "../../components/sabkType";
import ColorPickers from "../../components/colorPickers";
import CardType from "../../components/cardType";
import DesignType from "../../components/designType";
import DesignPaint from "../../components/designPaint";
import ComplicativeType from "../../components/complicativeType";
import ShapeType from "../../components/shapeType";
import HeaderSize from "../../components/headerSize";
import HeaderDesign from "../../components/headerDesign";
import HeaderDesignType from "../../components/headerDesignType";
import HeaderShape from "../../components/headerShape";
import Brochure from "../../components/brouchor";
import TarahiSet from "@/view/pages/components/tarahiSet";
import SetDesignType from "@/view/pages/components/setDesignType";
import ComplexSet from "@/view/pages/components/coplexSet";
import CardSides from "@/view/pages/components/cardSides";
import NotePhone from "@/view/pages/components/notePhone";
import FooldersType from "@/view/pages/components/foldersType";
import LetterSet from "@/view/pages/components/letterSet";
import {createFormData} from "@/Utilities/FormRequestHelper";
import OfficeType from "@/view/pages/site/office/officeType";
import NoteBook from "@/view/pages/site/office/material/noteBook";
import FolderMat from "@/view/pages/site/office/material/folderMat";
import LettrMat from "@/view/pages/site/office/material/letterMat";

export default {
    name: "setStepper",
    components: {
        LettrMat,
        FolderMat,
        NoteBook,
        OfficeType,
        LetterSet,
        FooldersType,
        NotePhone,
        CardSides,
        ComplexSet,
        SetDesignType,
        TarahiSet,
        Brochure,
        HeaderShape,
        HeaderDesignType,
        HeaderDesign,
        HeaderSize,
        ShapeType,
        ComplicativeType,
        DesignPaint, DesignType, CardType, ColorPickers, SabkType, Properties, LangType, LogoType
    },
    data() {
        return {
            step: 1,
            days: '',
            marker: true,
            editor: {
                editor: ClassicEditor,
                editorConfig: {
                    language: 'fa',
                    contentsLangDirection: 'rtl',
                    extraPlugins: [CKEditorUploadAdapterPlugin],
                }
            },
            mainPrice: "",
            dialogPayment: false,
            designs: false,
            payDialogInfo: {},
            orderType: [
                {text: 'فقط طراحی', value: 'design'},
                {text: 'طراحی به همراه چاپ', value: 'designPrint'},
            ],
            printType: [
                {text: 'فقط طراحی', value: 'design'},
                {text: 'طراحی به همراه چاپ', value: 'designPrint'},
            ],
            headerSize: [
                {text: 'A3', value: 'A3'},
                {text: 'A4', value: 'A4'},
                {text: 'A5', value: 'A5'},
                {text: 'A6', value: 'A6'},
                {text: 'B5', value: 'B5'},
            ],
            pocketSize: [
                {text: 'A4', value: 'A4'},
                {text: 'A5', value: 'A5'},
            ],
            noteSize: [
                {text: 'A4', value: 'A4'},
                {text: 'A5', value: 'A5'},
                {text: 'A6', value: 'A6'},
            ],
            notedirection: [
                {text: 'ازبالا', value: 'up'},
                {text: 'ازراست(فارسی)', value: 'right'},
                {text: 'ازچپ(لاتین)', value: 'left'},
            ],
            payableTransaction: null,
            brandSlogan: null,
            chosenSet: [],
            selectedRows: [],
            paymentLoading: false,
            data: {
                organizationName: null,
                material: {
                    'noteBook': null,
                    'folder': null,
                    'letter': null,
                    'visiCard': null
                },
                brandSlogan: null,
                slogan: 0,
                frontVisitText: null,
                pocketOrientation: null,
                backVisitText: null,
                pocketText: null,
                pocketSize: null,
                folderType: null,
                simpleness: null,
                noteBookType: null,
                orderType: null,
                shapeSet: null,
                noteBookSize: null,
                noteBookSide: null,
                noteBookText: null,
                folderText: null,
                printCount: null,
                designStyle: null,
                diagram: 'square',
                deliveryTime: null,
                complexity: null,
                sides: null,
                color: [],
                brandLogo: [],
                businessDescription: '',
                headerTexts: '',
                hasBrandSlogan: false,
                preferredCurrency: 'Rial',
                brandName: null,
                logoLanguage: null,
                size: [],
                orientation: "",
                user_price: '',
                type: null,
                logoType: null,
                site_type: null,
                file: [],
                description: '',
            },
            orderTypes: [
                {key: 'logo', keyAlias: 'طراحی لوگو', icon: '/media/site/aparat.png'},
                {key: 'visit_card', keyAlias: 'طراحی کارت ویزیت', icon: '/media/site/aparat.png'},
                {key: 'office_set', keyAlias: 'طراحی ست اداری', icon: '/media/site/aparat.png'},
                {key: 'header', keyAlias: 'طراحی سربرگ', icon: '/media/site/aparat.png'},
                {key: 'poster', keyAlias: 'طراحی پوستر', icon: '/media/site/aparat.png'},
                {key: 'office_scan', keyAlias: 'طراحی و چاپ اداری', icon: '/media/site/aparat.png'},
            ],
            errors: [],
            dialog: false,
            loading: false,
            rules: [
                v => !!v || 'وارد کردن این فیلد الزامی است'
            ],
            urlRules: [
                (value) => this.isURL(value) || "دامنه سایت باید بصورت https://terminalads.com یا terminalads.com وارد شود. ",
            ],
            errorMsg: '',
            nameErr: '',
            pageTitle: '',
            userWallet: [],
            dialogInfo: null,
            tab: null,
            items: [
                'سفارش ها',
                'ثبت سفارش جدید',
            ],
            userInfo: {},
            names: {},
            statusBadge: '',
            userValid: true,
            isRejected: false,
            isPending: false,
            articleDesc: false,
            enterMine: false,
            userInfoGot: false
        }
    },
    methods: {
        persianName(name, field) {
            this.names[field] = name
        },
        isURL(str) {
            var regex = new RegExp("^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?");
            var without_regex = new RegExp("^([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?");
            if (regex.test(str) || without_regex.test(str)) {
                return true
            } else {
                return false;
            }
        },
        paymentDialog(data) {
            this.payDialogInfo = data
            this.dialogPayment = true
        },
        step1Validate() {
            if (!this.data.organizationName || !this.data.brandName) {
                this.$toast.error('نام برند و نام مجموعه الزامی است.')
                return
            } else if (this.data.slogan && !this.data.brandSlogan) {
              this.$toast.error('لطفا شعار برند خودرا وارد کنید.')
            } else
            this.step = 2
        },
        step2Validate() {
            if (this.chosenSet.length <= 0) {
                this.$toast.error('انتخاب حداقل یک گزینه از ست اداری اجباری است.');
                return false
            } else {
                const conditions = {
                    header: () => {
                        if (this.data.size.length <= 0 || !this.data.orientation || !this.data.headerTexts) {
                            this.$toast.error('توضیحات و جهت و سایز سربرگ الزامی است .');
                            return false;
                        }
                        return true;
                    },
                    foolder: () => {
                        if (!this.data.folderType || !this.data.folderText) {
                            this.$toast.error('توضیحات ونوع فولدر الزامی است .');
                            return false;
                        }
                        return true;
                    },
                    visitCard: () => {
                        if (this.data.sides === 'twoSide' && (!this.data.shapeSet || !this.data.frontVisitText || !this.data.backVisitText)) {
                            this.$toast.error(' مندرجات کارت ویزیت الزامی هستند.');
                            return false;
                        } else if (!this.data.sides || !this.data.shapeSet || !this.data.frontVisitText) {
                            this.$toast.error(' شکل هندسی و توضیحات و نوع کارت ویزیت الزامی است.');
                            return false;
                        }
                        return true;
                    },
                    notebook: () => {
                        if (!this.data.noteBookSize || !this.data.noteBookSide || !this.data.noteBookText) {
                            this.$toast.error('جهت دفترچه وتوضیحات و سایز دفترچه الزامی است .');
                            return false;
                        }
                        return true;
                    },
                    letter: () => {
                        if (!this.data.pocketSize || !this.data.pocketOrientation || !this.data.pocketText) {
                            this.$toast.error('جهت وتوضیحات وسایز پاکت نامه الزامی است .');
                            return false;
                        }
                        return true;
                    }
                };
                let isValid = true;

                for (let item of this.chosenSet)
                    isValid = isValid && conditions[item]();

                if (isValid)
                    this.step = 3
            }
        },
        validIs() {
            const banner = [
                {main: this.data.logoLanguage, name: 'زبان طراحی  '},
                {main: this.data.color, name: 'رنگ '},
                {main: this.data.simpleness, name: 'سبک طراحی '},
                {main: this.data.complexity, name: 'نوع طراحی '},
                {main: this.data.orderType, name: 'نوع سفارش '},
            ];
            for (let val of banner) {
                if (val.main === null || val.main.length <= 0) {
                    this.$toast.error(val.name + 'ست اداری ' + 'الزامی است.');
                    return;
                }
            }

            const material = [
                {set: 'letter', main: this.data.material.letter, name: 'پاکت نامه  '},
                {set: 'visitCard', main: this.data.material.visiCard, name: 'کارت ویزیت '},
                {set: 'notebook', main: this.data.material.noteBook, name: 'دفتریادداشت '},
                {set: 'foolder', main: this.data.material.folder, name: 'پوشه '},
            ];

            if (this.data.orderType === 'designPrint' && !this.data.printCount) {
                this.$toast.error('تعداد چاپ الزامی است.')
                return
            }

            for (let val of material) {
                if (this.chosenSet.includes(val.set) && !val.main) {
                    this.$toast.error('جنس ' + val.name + 'الزامی است.');
                    return;
                }
            }

            this.step = 4
        },
        step3Validate() {
            if (this.data.type === 'office_set' && (this.data.brandLogo.length <= 0)) {
                this.$toast.error('لوگو برند الزامی است!')
                return
            }
            this.step = 5
        },
        step4Validate() {
            const banner = [
                {main: this.data.deliveryTime, name: 'تاریخ تحویل '},
                {main: this.data.businessDescription, name: 'توضیحات کسب وکار  '},
            ]
            for (let val of banner) {
                if (val.main === null || val.main.length <= 0) {
                    this.$toast.error(val.name + 'ست اداری ' + 'الزامی است.');
                    return;
                }
            }
            this.step = 6
        },
        submit() {
            if ((this.$route.name === 'support.index' && !this.data.description) || (this.$route.name === 'support.index' && !this.data.support_time)) {
                this.$toast.error('تمامی فیلدهای نمایش داده شده اجباری می باشند.');
                return;

            } else {
                this.loading = true
                this.requestApiPost(`form/graphic/officeSet`, createFormData(this.data))
                    .then((res) => {
                        this.loading = false
                        if (res.status && res.status === 201) {
                            this.$emit('eventname', 1)
                            this.$toast.success('با موفقیت ثبت شد.');
                        } else {
                            this.loading = false
                            this.$toast.warning('لطفا مجددا تلاش کنید')
                        }
                    })
                    .catch((e) => {
                        this.loading = false
                        if (e.response.status === 500) {
                            this.$toast.error('خطای سمت سرور!')
                        } else
                            this.$nextTick(() => {
                                this.$toast.error(Object.values(e.response.data.errors).map((x) => {
                                    return x.join('\n');
                                }).join(''));
                            })


                        this.errors = e.response.data.errors
                    })
                    .finally(() => {
                        this.loading = false
                        this.$modal.hideLoading();
                    })
            }
        },
        pay(transactionId) {
            if (this.payDialogInfo.payments.type === 'final') {

                this.requestApiPost(`payment/${this.payDialogInfo.id}/pay`, {transaction_id: this.payDialogInfo.payments.transactions[0].id})
                    .then(response => {
                        this.$toast.success('با موفقیت پرداخت شد!')
                        this.getSites()
                        this.dialogPayment = false
                    }).catch(({res}) => {
                    this.loading = false
                    this.$toast.error(res.data.message)
                })


            } else {
                this.requestApiPost(`payment/${this.payDialogInfo.id}/pay`, {transaction_id: transactionId})
                    .then(response => {
                        this.$toast.success('با موفقیت پرداخت شد!')
                        this.getSites()
                        this.dialogPayment = false
                    }).catch(({res}) => {
                    this.loading = false
                    this.$toast.error(res.data.message)
                })

            }
        },
        getSites(url = this.url, params = this.tableProps) {
            this.$modal.showLoading();
            this.requestApiGet(url, params).then(response => {
                this.userInfo = response.data;
            }).finally(() => {
                this.$modal.hideLoading();
                if (!this.userInfoGot) {
                    this.getUserInfo();
                }
            })
        },
        edit(data) {
            this.$router.push({name: 'admin.user.edit', params: {id: data.id}})
        },
        information(data) {
            this.$router.push({name: 'admin.users.information', params: {id: data.id}})
        },
        checkRoutes() {
            if (this.$route.name === 'officeSet.index') {
                this.data.type = 'office_set';
                this.pageTitle = this.orderTypes[2].keyAlias;
            } else if (this.$route.name === 'support.index') {
                this.data.type = 'support';
                this.pageTitle = this.orderTypes[1].keyAlias;
            } else if (this.$route.name === 'headerForm.index') {
                this.data.type = 'header';
                this.pageTitle = this.orderTypes[3].keyAlias;
            } else {
                this.data.type = 'visit_card';
                this.pageTitle = this.orderTypes[1].keyAlias;
            }

        },
        needsArtcile(value) {
            if (value === 'true') {
                this.articleDesc = true;
            } else this.articleDesc = false;
        },
        enterMyself(value) {
            if (value === 'true') {
                this.enterMine = true;
            } else this.enterMine = false;
        },
        redesign(value) {
            if (value === 'true') {
                this.data.redesign = 1;
            } else this.data.redesign = 0;
        },
        changeUnit() {
            this.marker = !this.marker;
            if (this.marker) {
                this.data.preferred_currency = 'Rial'
            } else this.data.preferred_currency = 'Toman'
        },
    },
    watch: {
        'data.name':
            function (value) {
                var regex = /^[a-zA-Z]+$/;
                if (value > 3 && !value.match(regex)) {
                    this.nameErr = 'نام مجموعه نمیتواند تنها شامل اعداد باشد.'
                } else
                    this.nameErr = '';
            },
        'data.hasBrandSlogan':
            function (value) {
                if (value) {
                    this.data.brandSlogan = this.brandSlogan;
                } else this.data.brandSlogan = null
            },
        chosenSet: {
            handler(val) {
                if (!val.includes('header')) {
                    this.data.size = []
                    this.data.orientation = null;
                    this.data.headerTexts = null;
                } else if (!val.includes('notebook')) {
                    this.data.noteBookSize = null;
                    this.data.noteBookSide = null;
                    this.data.noteBookText = null;
                } else if (!val.includes('foolder')) {
                    this.data.folderType = null;
                    this.data.folderText = null;
                } else if (!val.includes('visitCard')) {
                    this.data.sides = null;
                    this.data.shapeSet = null;
                    this.data.frontVisitText = null;
                } else if (!val.includes('letter')) {
                    this.data.pocketSize = null;
                    this.data.pocketOrientation = null;
                    this.data.pocketText = null;
                }
            },
            deep: true,
            immediate: true

        },
        'data.slogan': function (value) {
            if (value) {
                this.data.slogan = 1
            } else this.data.slogan = 0
        }
    },
    computed: {
        printCounting: {
            get() {
                // return this.data.printCount
            }
            ,
            set(value) {
                this.data.printCount = value * 1000;
            }
            ,
        }
        ,
        main_price: {
            get() {
                return this.$options.filters.currency(this.data.user_price)
            }
            ,
            set(value) {
                this.data.user_price = value.replaceAll(',', '')
            }
        }
        ,
        countDay: {
            get() {
                const minimum_day = new Date();
                minimum_day.setDate(minimum_day.getDate() + 5);
                return minimum_day;
            }
            ,
            set(value) {
            }
        }
    },
    mounted() {
        this.checkRoutes();
    }
}
</script>

<style scoped>

</style>